<template>
	<div id="real-name" class="form-container" style="text-align:center">
		<h2>{{$t('nav.RealNameAuthentication')}}</h2>
		<template v-if="user.anti_level>0">
			<div class="form-item">
				<label for="">{{$t("realName.Name")}}:</label>
				{{name}}
			</div>
			<div class="form-item">
				<label for="">{{$t("realName.IDCard")}}:</label>
				{{card}}
			</div>
			<div class="form-item">
				<label for=""></label>
				<wd-button type="danger" size="large"  @click.native="modify" :styles="{width:'300px'}">{{$t("home.Change")}}</wd-button>
			</div>
			<p class="real-tip">{{$t('realName.ModifyTip')}}</p>
		</template>
		<template v-else>
			<template v-if="status<1">
				<div class="form-item">
					<label for="">{{$t("realName.Name")}}</label>
					<input type="text" v-model="real_name" @focus="validated = false" :class="(validated && !real_name) ? 'error' : ''" :placeholder="$t('realName.NameTip')">
				</div>
				<div class="form-item">
					<label for="">{{$t("realName.IDCard")}}</label>
					<input type="text" v-model.trim="card_id" @focus="validated = false" :class="(validated && !card_id) ? 'error' : ''" :placeholder="$t('realName.IDCardTip')">
				</div>
				<div class="form-item">
					<label for=""></label>
					<wd-button type="danger" @click.native="submit" size="large" :styles="{width:'300px'}">{{$t("default.submit")}}</wd-button>
				</div>
				<p class="real-tip">{{failTip}}</p>
			</template>
			<template v-else >
                <div class="rotate-box">
                    <div class="wrapper" data-anim="base wrapper">
                        <div class="circle" data-anim="base left"></div>
                        <div class="circle" data-anim="base right"></div>
                    </div>
                    <div v-if="isComplete" :class="['rotate-complete',level>0?'success':'fail']"></div>
                </div>
                <div class="rotate-tip">{{realTip}}</div>
				<wd-button v-if="level > 0 && isComplete" type="danger" @click.native="confirm" size="large" :styles="{width:'300px',margin:'0 auto'}">{{$t("default.Done")}}</wd-button>
				<wd-button v-if="level == 0 && isComplete" type="danger" @click.native="reApprove" size="large" :styles="{width:'300px',margin:'0 auto'}">{{$t("realName.ReCertification")}}</wd-button>
            </template> 
		</template>
	</div>
</template>
<script>
	import WdButton from '@/components/WdButton.vue';
	export default{
		name:"realName",
		data(){
			return {
				lang:this.$i18n.locale,
				user:{
					anti_level:0
				},
				real_name:"",
				card_id:"",
				isComplete:false,
				level:0,
				status:0,// 0待认证1认证中
				realTip:'',
				failTip:'',
				validated:false,
				cityArr:{ 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆" , 71: "台湾", 81: "香港", 82: "澳门"}
			}
		},
		components:{
			'wd-button':WdButton
		},
		computed:{
			name(){
				let val = this.real_name;
				if(!val) return '';
				if(this.lang == 'zh'){
					let l = val.length;
					if(l<4){
						return val.substr(0,1)+'*'+val.substr(2,1)
					}else{
						return val.substr(0,2)+'*'+val.substr(3,l)
					}
				}else{
					return  val;
				}
			},
			card(){
				let val = this.card_id;
				if(!val) return '';
				let l = val.length;
				if(this.lang == 'zh' && l == 18){
					return val.substr(0,3)+'******'+val.substr(17,l);
				}else{
					return val;
				}
			}
		},
		methods:{
			async submit(){
				this.validated = true;
				if(!this.real_name){
					this.$alert(this.$t("realName.NameTip"))
					return;
				}
				if(!this.card_id){
					this.$alert(this.$t("realName.IDCardTip"))
					return;
				}
				if(this.$i18n.locale == 'zh'){
					let msg = this.CheckIdentityCode(this.card_id);
					if(msg != 1) return
				}
				let postData = {real_name:this.real_name,card_id:this.card_id};
				let response = await this.$api.post('/web/index/realName',postData);
				
				if(response.code == 0){
					this.status = 1;
					setTimeout(()=> {
						this.toRealName();
					},3000)
				}else {
					this.$alert(response.msg)
				}
			},
			async toRealName(){// 查看实名认证状态
				let res = await this.$api.get('/web/index/checkRealName');
				if(res.code == 0){
					this.level = res.data.anti_level;
					this.isComplete = true;
					if(res.data.anti_level == 0){
						this.realTip = this.$t('realName.SetRealnameFail');
					}else {
						this.realTip = this.$t('realName.SetRealnameSuccess');
						this.$setUser({real_name:this.real_name,card_id:this.card_id,anti_level:res.data.anti_level});
					}
				}else {
					this.level = 0;
					this.realTip = this.$t('realName.SetRealnameFail');
					this.isComplete = true;
				}
			},
			CheckIdentityCode(code) {
				let reg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/i;
				if (!reg.test(code)) {
					this.$alert("格式不正确！")
					return 0;
				}
				code = code.replace(/x$/i, "a");
				if (this.cityArr[parseInt(code.substr(0, 2))] == null) {
					this.$alert("包含非法地区！")
					return 0;
				}
				let birthDay = code.substr(6, 4) + "-" + Number(code.substr(10, 2)) + "-" + Number(code.substr(12, 2));
				var d = new Date(birthDay.replace(/-/g, "/"));
				if (birthDay != (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate())) {
					this.$alert("包含非法出生日期！")
					return 0;
				}
				return 1;
			},
			modify(){
				let lang = (this.$i18n.locale=='zh' || this.$i18n.locale=='tw') ?'zh':'en';
				let url = 'http://www.wooduan.com/service?lang='+lang
				window.open(url)
			},
			reApprove() {
				this.status = 0;
				this.isComplete = false;
				this.realTip = '';
			},
			confirm(){
				this.$set(this.user,'anti_level',this.level)
			}
		},

		async created(){
			let user = await this.$getUser();
			if(user){
				if(user.anti_level>0){
					this.real_name = user.real_name;
					this.card_id = user.card_id;
				}else if(user.real_name) {
					this.failTip = this.$t('realName.MisMatch');
				}
				this.user = user
			}
		}	
	}
</script>
<style scoped>
	.form-container{
		margin-top: 50px;
	}
	.real-tip{
		color: #ce292d;
		width: 100%;
		text-align: center;
		font-size: 12px;
	}
	.rotate-tip {
        color: #ce292d;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
		margin-bottom: 20px;
    }
    .rotate-box{
        width: 194px;
        height: 194px;
        margin: 20px auto;
        position: relative;
        background: url(../assets/real-icon.png) no-repeat;
        background-size: 100% 100%;
    }
    .rotate-box .rotate-complete{
        position: absolute;
        bottom: 0;
        right: 14px;
        z-index: 3;
        width: 48px;
        height: 48px;
    }
    .rotate-box .success{
        background: url(../assets/complete1.png) no-repeat;   
        background-size: 100% 100%;
    }
     .rotate-box .fail{
        background: url(../assets/fail.png) no-repeat;
        background-size: 100% 100%;
    }
    .rotate-box .wrapper {
        width: 200px; 
        height: 200px;
        position: absolute; /* Enable clipping */
        clip: rect(0, 200px, 200px, 100px);
        top: -3px;
        left: -3px;
    }
    .rotate-box .circle {
        width: 188px;
        height: 188px;
        border: 6px solid #ffe4b5;
        border-radius: 50%;
        position: absolute;
        clip: rect(0, 100px, 200px, 0);
    }
    .rotate-box div[data-anim~=base] {
        animation-iteration-count: 1;  /* Only run once */
        animation-fill-mode: forwards; /* Hold the last keyframe */
        animation-timing-function:linear; /* Linear animation */
    }

    .rotate-box .wrapper[data-anim~=wrapper] {
        animation-duration: 0.01s; /* Complete keyframes asap */
        animation-delay: 1.5s; /* Wait half of the animation */
        animation-name: close-wrapper; /* Keyframes name */
    }

    .rotate-box .circle[data-anim~=left] {
        animation-duration: 3s; 
        animation-name: left-spin;
    }

    .rotate-box .circle[data-anim~=right] {
        animation-duration: 1.5s;
        animation-name: right-spin;
    }

    @keyframes right-spin {
        from {
        -webkit-transform: rotate(0deg);
        }
        to {
        -webkit-transform: rotate(180deg);
        }
    }
    @keyframes left-spin {
        from {
        -webkit-transform: rotate(0deg);
        }
        to {
        -webkit-transform: rotate(360deg);
        }
    }
    @keyframes close-wrapper {
        to {
        clip: rect(auto, auto, auto, auto);
        }
    }
    @keyframes show-complete {
        to {
            opacity: 1;
        }
    }
</style>
